import Link from "next/link";
import Img from "next/image";
import { string, shape, bool, array, arrayOf, object } from "prop-types";
import { getLink } from "@lib/getLink";
import { client } from "@lib/sanity";
import { useNextSanityImage } from "@hooks/useNextSanityImage";

const NextSanityImage = ({ img, alt }) => {
  const imageProps = useNextSanityImage(client, img);

  return (
    <Img alt={alt} layout="responsive" sizes={`(min-width: 45em) 80vw, 100vw`} {...imageProps} />
  );
};

export const Image = ({ data }) => {
  const link = data.link ? getLink(data.link) : null;

  if (data.link) {
    return (
      <Link href={link.href}>
        <a>
          <NextSanityImage img={data} alt={data.altText} />
        </a>
      </Link>
    );
  }

  return <NextSanityImage img={data} alt={data.altText} />;
};

Image.propTypes = {
  _key: string,
  _type: string,
  altText: string,
  isSmall: bool,
  isPortrait: bool,
  asset: shape({
    _ref: string,
    _type: string,
  }),
  link: shape({
    handle: string,
    link: object,
    productGroup: array,
    refTitle: string,
    slug: object,
    type: string,
  }),
  text: shape({
    _type: string,
    content: arrayOf(
      shape({
        _key: string,
        _type: string,
        style: string,
        children: arrayOf(
          shape({
            _key: string,
            _type: string,
            marks: array,
            text: string,
          })
        ),
        markDefs: array,
      })
    ),
  }),
};
